module.exports = __webpack_public_path__ + "static/img/inomph_logo_md.ffe5f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/inomph_logo_md.png
// module id = /Cso
// module chunks = 1